import axios from "~/plugins/axios";

export default {
  find(id, includes = []) {
    return axios.get(`/web_api/v1/letter_layout/${id}`, {
      params: {
        include: includes,
      },
    })
      .then((response) => response.data);
  },
  store(letterLayout) {
    const url = "/web_api/v1/letter_layout/";
    return axios.post(url, letterLayout)
      .then((response) => response.data);
  },
  storeStationery(file, letterLayout) {
    const url = `/web_api/v1/letter_layout/${letterLayout.id}/stationery`;
    const formData = new FormData();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    formData.append("file", file);

    return axios.post(url, formData, config)
      .then((response) => response.data);
  },
  destroyStationery(letterLayout) {
    const url = `/web_api/v1/letter_layout/${letterLayout.id}/stationery`;
    return axios.delete(url)
      .then((response) => response.data);
  },
  update(letterLayout) {
    const url = `/web_api/v1/letter_layout/${letterLayout.id}`;
    return axios.put(url, letterLayout)
      .then((response) => response.data);
  },
  delete(id) {
    return axios.delete(`/web_api/v1/letter_layout/${id}`)
      .then((response) => response.data);
  },
};
